import { render, staticRenderFns } from "./appearance.vue?vue&type=template&id=22992eac"
import script from "./appearance.vue?vue&type=script&lang=ts"
export * from "./appearance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports